import TranslateComponent from './Translate.vue';

export const translateRoutes = {
  path: '/translate',
  name: 'Translate',
  component: TranslateComponent,
  meta: {
    title: 'Translate',
    requireAuth: true
  }
};
